import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../../../store'

interface INavbarStateState {
  snapQuoteIdentifier?: string | null
  snapQuoteIdentifierType?: string | null
  openSnapQuotePopover?: boolean
}

const initialState: INavbarStateState = {
  openSnapQuotePopover: false
}

const Slice = createSlice({
  name: '@shared/rcmnavbar',
  initialState,
  reducers: {
    SetSnapQuoteIdentifierState: (state, action: PayloadAction<string | undefined | null>) => {
      return { ...state, snapQuoteIdentifier: action.payload }
    },
    SetSnapQuoteIdentifierTypeState: (state, action: PayloadAction<string | undefined | null>) => {
      return { ...state, snapQuoteIdentifierType: action.payload }
    },
    OpenSnapQuotePopover: (state, action: PayloadAction<{ identifier: string; identifierType: string }>) => {
      return {
        ...state,
        snapQuoteIdentifier: action.payload.identifier,
        snapQuoteIdentifierType: action.payload.identifierType,
        openSnapQuotePopover: true
      }
    },
    CloseSnapQuotePopover: (state) => {
      return {
        ...state,
        snapQuoteIdentifier: undefined,
        snapQuoteIdentifierType: undefined,
        openSnapQuotePopover: false
      }
    }
  }
})

export const {
  SetSnapQuoteIdentifierState,
  SetSnapQuoteIdentifierTypeState,
  OpenSnapQuotePopover,
  CloseSnapQuotePopover
} = Slice.actions
export const getSnapQuoteIdentifier = (state: RootState) => state.shared.rcmNavbar.snapQuoteIdentifier
export const getSnapQuoteIdentifierType = (state: RootState) => state.shared.rcmNavbar.snapQuoteIdentifierType
export const getOpenSnapQuotePopover = (state: RootState) => state.shared.rcmNavbar.openSnapQuotePopover
export default Slice.reducer
